module.exports = __webpack_public_path__ + "images/triumph_small24b00d6985f54653c43dbbf894aa4ffd.png";